import { render, staticRenderFns } from "./NavigationDrawerLeft.vue?vue&type=template&id=65a805b0"
import script from "./NavigationDrawerLeft.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerLeft.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerLeft.vue?vue&type=style&index=0&id=65a805b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports